/**
 * Traduce el error de una Cloud Function callable a un mensaje para el usuario. Las callables
 * del proxy ya mandan mensajes claros (guard, precondición, validación); aquí solo se cae a un
 * genérico cuando no hay mensaje. El backend nunca filtra el cuerpo del NOTIF-API (SEC-03).
 */
export function mensajeError(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const m = (err as { message?: unknown }).message;
    if (typeof m === 'string' && m.trim()) return m;
  }
  return 'No se pudo completar la operación. Intente de nuevo.';
}
